import { ComingSoon } from "@/components/ComingSoon";
import { MapPin, Stethoscope, Calendar, Video, CreditCard } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { ReactNode } from "react";

const iconMap: Record<string, LucideIcon> = {
  MapPin,
  Stethoscope,
  Calendar,
  Video,
  CreditCard,
};

interface FeatureGateProps {
  title: string;
  description?: string;
  icon: string;
  locked?: boolean;
  children?: ReactNode;
}

export function FeatureGate({ title, description, icon, locked = true, children }: FeatureGateProps) {
  const IconComponent = iconMap[icon] || Stethoscope;

  if (!locked && children) {
    return <>{children}</>;
  }

  return <ComingSoon title={title} description={description} icon={IconComponent} />;
}
